var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block",
      shapeRendering: "auto"
    },
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 40,
    x: 17.5,
    y: 30,
    fill: "#f9ba86"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "-0.4s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "10;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "-0.4s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "80;40;40"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 40,
    x: 42.5,
    y: 30,
    fill: "#f69e55"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "-0.2s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "-0.2s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "70;40;40"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 40,
    x: 67.5,
    y: 30,
    fill: "#f48024"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "70;40;40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSpinner);
export default __webpack_public_path__ + "static/media/PageSpinner.53b13299eedfde70726d683794cda605.svg";
export { ForwardRef as ReactComponent };